module.exports = __webpack_public_path__ + "img/fish.7c9d27e1.svg";